import ErrorWithCause from '@helpers/ErrorWithCause';
import axios from 'axios';
import { SHOPPING_CART_API_BASE_URL } from '@config/apiConfig';
const getCart = async () => {
    try {
        const response = await axios.get(`${SHOPPING_CART_API_BASE_URL}/cart`);
        return response.data;
    }
    catch (error) {
        throw new ErrorWithCause(error);
    }
};
export default getCart;
